import React, { useState } from 'react';
import logo from '../assets/logo.png';
function Header() {

  return (
    <header className="header">
      <div className="header-content">
        
         <img src={logo} alt="Haivest Logo" className="logo" />
        <nav className="nav-links">
          <a href="#features">Fonctionnalités</a>
          <a href="#how-it-works">Comment ça marche</a>
          <a href="#contact">Contact</a>
          <a href="#login" className="login-btn">Connexion</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
